import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CiscoPbxExportRef } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MigrationsCiscoResource {
  private _http = inject(HttpClient);

  createAssessment(
    tenantId: string,
    name: string,
    tar: File,
    cdr?: File,
    unity?: File,
    cerErl?: File,
    cerSubnet?: File,
    cerAccessPoint?: File,
    cerSwitch?: File,
    cerSwitchPort?: File,
  ): Observable<HttpEvent<CiscoPbxExportRef>> {
    return this._create(tenantId, name, tar, cdr, unity, cerErl, cerSubnet, cerAccessPoint, cerSwitch, cerSwitchPort);
  }

  deleteAssessment(tenantId: string, exportId: string): Observable<void> {
    return this._delete(tenantId, exportId);
  }

  private _create(
    tenantId: string,
    name: string,
    tar: File,
    cdr?: File,
    unity?: File,
    cerErl?: File,
    cerSubnet?: File,
    cerAccessPoint?: File,
    cerSwitch?: File,
    cerSwitchPort?: File,
  ): Observable<HttpEvent<CiscoPbxExportRef>> {
    const formData = new FormData();
    formData.append('name', name);

    formData.append('cucmTarExport', tar.name);
    formData.append('upload', tar);

    if (cdr) {
      formData.append('cucmCdrDump', cdr.name);
      formData.append('upload', cdr);
    }

    if (unity) {
      formData.append('cucZipExport', unity.name);
      formData.append('upload', unity);
    }

    if (cerErl) {
      formData.append('cerErlExport', cerErl.name);
      formData.append('upload', cerErl);
    }

    if (cerSubnet) {
      formData.append('cerSubnetExport', cerSubnet.name);
      formData.append('upload', cerSubnet);
    }

    if (cerAccessPoint) {
      formData.append('cerApExport', cerAccessPoint.name);
      formData.append('upload', cerAccessPoint);
    }

    if (cerSwitch) {
      formData.append('cerSwitchExport', cerSwitch.name);
      formData.append('upload', cerSwitch);
    }

    if (cerSwitchPort) {
      formData.append('cerSwitchPortExport', cerSwitchPort.name);
      formData.append('upload', cerSwitchPort);
    }

    return this._http.post<CiscoPbxExportRef>(
      `/services/microsoft/migrations/tenants/${tenantId}/exports/cisco`,
      formData,
      { reportProgress: true, observe: 'events' },
    );
  }

  private _delete(tenantId: string, exportId: string): Observable<void> {
    return this._http.delete<void>(`/services/microsoft/migrations/tenants/${tenantId}/exports/cisco/${exportId}`);
  }
}
